module.exports = __webpack_public_path__ + "assets/img/pitch.png?9688b9b4e00bd146d8c0af1f1687f323";